import gql from 'graphql-tag';

/************************************************
  USER
 ************************************************/

export const GET_CURRENT_USER = gql`
  query getCurrentUser {
    getCurrentUser {
      _id
      email
      phoneNumber
      firstName
      organizationContextId
      currentOrganizationRole
      lastName
      couponIds
      visitIds
      guidedOnboardingEnabled
    }
  }
`;

export const DISMISS_ONBOARDING_COMPLETE_MODAL = gql`
  mutation dismissOnboardingCompleteModal {
    dismissOnboardingCompleteModal {
      _id
      onboardingCompleteModalDismissed
    }
  }
`;

export const UPDATE_USER_INFO = gql`
  mutation updateUserInfo(
    $email: String!
    $firstName: String!
    $lastName: String!
    $phoneNumber: String!
  ) {
    updateUserInfo(
      email: $email
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
    ) {
      _id
      email
      phoneNumber
      firstName
      organizationContextId
      currentOrganizationRole
      lastName
      couponIds
      visitIds
      guidedOnboardingEnabled
    }
  }
`;

export const CHECK_USER_EXISTS = gql`
  query checkUserExists($email: String!, $phoneNumber: String!) {
    checkUserExists(email: $email, phoneNumber: $phoneNumber)
  }
`;

export const NOTIFY_ACCOUNT_SETUP_ERROR = gql`
  mutation notifyAccountSetupError($input: NotifyAccountSetupErrorInput!) {
    notifyAccountSetupError(input: $input)
  }
`;

export const REGISTER_USER = gql`
  mutation register(
    $email: String!
    $firstName: String!
    $lastName: String!
    $phoneNumber: String!
    $password: String!
  ) {
    register(
      email: $email
      firstName: $firstName
      lastName: $lastName
      phoneNumber: $phoneNumber
      password: $password
    ) {
      token
    }
  }
`;

export const PASSWORD_LOGIN = gql`
  mutation passwordLogin($email: String!, $password: String!) {
    passwordLogin(email: $email, password: $password) {
      token
    }
  }
`;

export const PASSWORD_FORGOT = gql`
  mutation passwordForgot($email: String!) {
    passwordForgot(email: $email) {
      message
    }
  }
`;

export const PASSWORD_RESET = gql`
  mutation passwordReset($password: String!, $code: String!) {
    passwordReset(password: $password, code: $code) {
      message
      status
    }
  }
`;

export const PHONE_LOGIN = gql`
  mutation phoneLogin($email: String!, $phoneNumber: String!) {
    phoneLogin(email: $email, phoneNumber: $PhoneNumber) {
      token
    }
  }
`;

export const FIND_USER_BY_PHONE_NUMBER = gql`
  mutation findUserByPhoneNumber($phoneNumber: String!) {
    findUserByPhoneNumber(phoneNumber: $phoneNumber) {
      _id
      firstName
      lastName
      email
      phoneNumber
    }
  }
`;

/************************************************
  ORGANIZATION
 ************************************************/

export const CREATE_ORGANIZATION = gql`
  mutation createOrganization(
    $name: String!
    $ownerName: String!
    $ownerEmail: String!,
    $ownerPhoneNumber: String!,
    $address: AddressInput
    $logoUrl: String!
    $posterImageUrl: String!
    $timezoneId: String!
  ) {
    createOrganization(
      name: $name
      ownerName: $ownerName
      ownerEmail:$ownerEmail
      ownerPhoneNumber: $ownerPhoneNumber
      address: $address
      logoUrl: $logoUrl
      posterImageUrl: $posterImageUrl
      timezoneId: $timezoneId
    ) {
      token
    }
  }
`;

export const GET_CURRENT_ORGANIZATION = gql`
  query getCurrentOrganization {
    getCurrentOrganization {
      _id
      name
      ownerName
      ownerEmail
      ownerPhoneNumber
      createdAt
      logoUrl
      posterImageUrl
      base64_logoUrl
      base64_posterImageUrl
      activeSubscriber
      subscriptionId
      address {
        address1
        address2
        city
        state
        zip
        country
      }
      integration {
        headline
        buttonColor
        buttonTextColor
        backgroundColor
        introductoryText
        integrationType
        successText
        tags
      }
      configurations {
        affiliateCredit
        firstTimeRecipientCredit
        repeatRecipientCredit
        returnLimit
        couponActivationExpiration
        couponRedemptionExpiration
        welcomeMessage
        websiteUrl
        reservationUrl,
        inviteMessage
      }
      keyword
      phrase
      description
      referralOptIn
      enrollmentText
      phoneNumber
      mmsEnabled
      timezone {
        value: _id
        label: zoneName
        name
        offset
        dstOffset
      }
      campaignPhoneNumber
      shortcode
      tags,
      minMonthlyCharges,
      campaignFollowUpEnabled,
      perPersonAverage,
      averagePartySize,
      conversionRate,
      referralMarketingEnabled,
      smsCampaign {
        OptInAt
      }
      onboardingChecklistProgress {
        step1AccountComplete
        step2PaymentComplete
        step3SmsComplete
        guestListComplete
        widgetComplete
        qrCodeComplete
        campaignComplete
        allComplete
      }
      onboardingCompleteModalDismissed
    }
  }
`;

export const UPDATE_ONBOARDING_CHECKLIST_PROGRESS = gql`
  mutation updateOnboardingChecklistProgress(
    $input: OnboardingChecklistProgressInput!
  ) {
    updateOnboardingChecklistProgress(input: $input) {
      _id
      onboardingChecklistProgress {
        step1AccountComplete
        step2PaymentComplete
        step3SmsComplete
        guestListComplete
        widgetComplete
        qrCodeComplete
        campaignComplete
        allComplete
      }
    }
  }
`;

export const GET_SHORT_ORG = gql`
  query getCurrentOrganization {
    getCurrentOrganization {
      _id
      name
      address {
        address1
        address2
        city
        state
        zip
        country
      }
      user {
        firstName
        lastName
      }
      ownerName
      tags
    }
  }
`;

export const UPDATE_ORGANIZATION_INFO = gql`
  mutation updateOrganizationInfo(
    $name: String!
    $ownerName: String!
    $ownerEmail: String!
    $ownerPhoneNumber:String!
    $address: AddressInput
    $logoUrl: String!
    $posterImageUrl: String!
    $timezoneId: String
  ) {
    updateOrganizationInfo(
      name: $name
      ownerName: $ownerName
      ownerEmail: $ownerEmail
      ownerPhoneNumber: $ownerPhoneNumber
      address: $address
      logoUrl: $logoUrl
      timezoneId: $timezoneId
      posterImageUrl: $posterImageUrl
    ) {
      _id
      name
      ownerName
      createdAt
      logoUrl
      posterImageUrl
      activeSubscriber
      subscriptionId
      address {
        address1
        address2
        city
        state
        zip
        country
      }
      configurations {
        affiliateCredit
        firstTimeRecipientCredit
        repeatRecipientCredit
        returnLimit
        couponActivationExpiration
        couponRedemptionExpiration
        websiteUrl
        reservationUrl
        welcomeMessage
      }
      keyword
      phrase
      phoneNumber
      timezone {
        value: _id
        label: zoneName
        name
        offset
        dstOffset
      }
    }
  }
`;

export const UPDATE_ORGANIZATION_SELF_OPT_IN = gql`
  mutation updateOrganizationSelfOptIn($keyword: String!, $phrase: String!, $description: String!, $enrollmentText:String,$referralOptIn:Boolean) {
    updateOrganizationSelfOptIn(keyword: $keyword, phrase: $phrase, description : $description , enrollmentText:$enrollmentText,referralOptIn:$referralOptIn) {
      _id
      name
      createdAt
      logoUrl
      posterImageUrl
      activeSubscriber
      subscriptionId
      address {
        address1
        address2
        city
        state
        zip
        country
      }
      configurations {
        affiliateCredit
        firstTimeRecipientCredit
        repeatRecipientCredit
        returnLimit
        couponActivationExpiration
        couponRedemptionExpiration
        websiteUrl
        reservationUrl
        welcomeMessage
      }
      keyword
      phrase
      description
      enrollmentText
      referralOptIn
      phoneNumber
      timezone {
        value: _id
        label: zoneName
        name
        offset
        dstOffset
      }
    }
  }
`;

export const UPDATE_ORGANIZATION_CONFIGURATION = gql`
  mutation updateOrganizationConfiguration(
    $configurations: OrganizationConfigurationsInput!
  ) {
    updateOrganizationConfiguration(configurations: $configurations) {
      _id
      name
      createdAt
      logoUrl
      posterImageUrl
      activeSubscriber
      subscriptionId
      address {
        address1
        address2
        city
        state
        zip
        country
      }
      configurations {
        affiliateCredit
        firstTimeRecipientCredit
        repeatRecipientCredit
        returnLimit
        couponActivationExpiration
        couponRedemptionExpiration
        websiteUrl
        reservationUrl
        welcomeMessage
      }
      keyword
      phrase
      phoneNumber
      timezone {
        value: _id
        label: zoneName
        name
        offset
        dstOffset
      }
    }
  }
`;

export const UPDATE_ORGANIZATION_ROI_SETTINGS = gql`
  mutation updateOrganizationROISettings(
    $campaignFollowUpEnabled: Boolean
    $perPersonAverage: Int
    $averagePartySize: Int
    $conversionRate: Int
  ) {
    updateOrganizationROISettings(
      campaignFollowUpEnabled: $campaignFollowUpEnabled
      perPersonAverage: $perPersonAverage
      averagePartySize: $averagePartySize
      conversionRate: $conversionRate
    ) {
      _id
      campaignFollowUpEnabled
      perPersonAverage
      averagePartySize
      conversionRate
    }
  }
`;

export const GET_ALL_ORGANIZATIONS = gql`
  query getAllOrganizations ($start: Int!, $end: Int!){
    getAllOrganizations (start: $start, end: $end){
      _id
      name
      createdAt
      ltv
      upcomingRevenue
      minMonthlyCharges
      cycleStartAt
      cycleEndAt
      campaignPhoneNumber
      phoneNumber
      mmsEnabled
      totalContacts
      totalCampaigns
      campaignCreditsUsed
    }
  }
`;

export const SET_ORG_CONTEXT_ID = gql`
  mutation setOrganizationContextId($organizationId: String!) {
    setOrganizationContextId(organizationId: $organizationId) {
      token
    }
  }
`;

export const UPDATE_SHORTCODE = gql`
  mutation updateOrganizationShortcode($shortcode: String!,$minMonthlyCharges:Int) {
    updateOrganizationShortcode(shortcode: $shortcode, minMonthlyCharges:$minMonthlyCharges) {
      _id
      shortcode,
      minMonthlyCharges
    }
  }
`;

export const UPDATE_ORG_INTEGRATION = gql`
  mutation updateOrgIntegrationSetting($integration: IntegrationInput) {
    updateOrgIntegrationSetting(integration: $integration) {
      integration {
        headline
        buttonColor
        buttonTextColor
        backgroundColor
        introductoryText
        integrationType
        successText
        tags
      }
    }
  }
`;

export const GET_USER_ORGANIZATION = gql`
  query getUserOrganization {
    getUserOrganization {
      _id
      userId
      phoneNumber
      organizationId
      acceptedAt
      accessLevel
      organization {
        _id
        name
      }
    }
  }
`;

export const SWITCH_ORGANIZATION = gql`
  mutation switchOrganization($organizationId: String!) {
    switchOrganization(organizationId: $organizationId) {
      user {
        _id
        firstName
        lastName
        email
        phoneNumber
        organizationContextId
        currentOrganizationRole
      }
      token
    }
  }
`;

/************************************************
  ROLES
 ************************************************/

export const GET_ORGANIZATION_ROLES = gql`
  query getOrganizaationRoles {
    getOrganizationRoles {
      _id
      userId
      phoneNumber
      organizationId
      acceptedAt
      accessLevel
      user {
        firstName
        lastName
        email
        phoneNumber
      }
    }
  }
`;

export const GET_USER_ROLES = gql`
  query getUserRoles {
    getUserRoles {
      _id
      userId
      phoneNumber
      organizationId
      acceptedAt
      accessLevel
      user {
        firstName
        lastName
        email
        phoneNumber
      }
      organization {
        name
        logoUrl
      }
    }
  }
`;

export const CREATE_ROLE = gql`
  mutation createRole($phoneNumber: String!, $accessLevel: String!, $userId:String, $email:String!) {
    createRole(phoneNumber: $phoneNumber, accessLevel: $accessLevel, userId:$userId, email:$email) {
      _id
      userId
      phoneNumber
      organizationId
      acceptedAt
      accessLevel
      email
    }
  }
`;

export const DELETE_ROLE = gql`
  mutation deleteRole($roleId: String!) {
    deleteRole(roleId: $roleId)
  }
`;

export const ACCEPT_ROLE = gql`
  mutation acceptRole(
    $roleId: String!
    $doesAccept: Boolean!
    $phoneCode: String!
  ) {
    acceptRole(
      roleId: $roleId
      doesAccept: $doesAccept
      phoneCode: $phoneCode
    ) {
      token
    }
  }
`;

/************************************************
  CONTACT
 ************************************************/

export const CREATE_CONTACTS = gql`
  mutation createContacts($phoneNumber: [String]!, $tags: [String]) {
    createContacts(phoneNumber: $phoneNumber, tags: $tags)
  }
`;

export const GET_CONTACTS = gql`
  query getContacts(
    $query: ContactQueryInput
    $pagination: PaginationInput
    $ordering: OrderingInput
  ) {
    getContacts(query: $query, pagination: $pagination, ordering: $ordering) {
      _id
      phoneNumber
      organizationId
      createdAt
      lastImported
      attendedOrganization
      welcomed
      currentAvailableBalance
      originalSource
      optInMethod
      lastOptIn
      optOut
      totalCreditGranted
      totalCreditRedeemed
      totalCouponsGranted
      totalCouponsRedeemed
      totalCouponsAcceptedRef
      totalCouponsRedRef
      totalConversionRateRef
      smsCampaignOptOut
      totalRefClicks
      attachedTags: tags
    }
  }
`;

export const GET_CONTACTS_WITHOUT_REFERRAL = gql`
  query getContacts(
    $query: ContactQueryInput
    $pagination: PaginationInput
    $ordering: OrderingInput
  ) {
    getContacts(query: $query, pagination: $pagination, ordering: $ordering) {
      _id
      phoneNumber
      organizationId
      createdAt
      lastImported
      attendedOrganization
      welcomed
      originalSource
      optInMethod
      lastOptIn
      optOut
      smsCampaignOptOut
      attachedTags: tags
    }
  }
`;

export const GET_SUPERADMIN_FILTERS_DATA = gql`
  query getSuperAdminFiltersData {
    getSuperAdminFiltersData {
      organizations {
        _id
        name
      }
    }
  }
`;

export const GET_SUPERADMIN_CONTACTS = gql`
  query getSuperAdminContacts($query: SuperAdminContactsInput) {
    getSuperAdminContacts(query: $query) {
      _id
      phoneNumber
      organizationName
      organizationId
      createdAt
      lastImported
      attendedOrganization
      welcomed
      currentAvailableBalance
      originalSource
      optInMethod
      lastOptIn
      optOut
      totalCreditGranted
      totalCreditRedeemed
      totalCouponsGranted
      totalCouponsRedeemed
      totalCouponsAcceptedRef
      totalCouponsRedRef
      totalConversionRateRef
      smsCampaignOptOut
      totalRefClicks
    }
  }
`;

export const GET_DASHBOARD_STAT_CONTACTS = gql`
  query getDashboardStatContacts($query: DashboardStatContactsQuery) {
    getDashboardStatContacts(query: $query) {
      _id
      phoneNumber
      organizationName
      organizationId
      createdAt
      lastImported
      attendedOrganization
      welcomed
      currentAvailableBalance
      originalSource
      optInMethod
      lastOptIn
      optOut
      totalCreditGranted
      totalCreditRedeemed
      totalCouponsGranted
      totalCouponsRedeemed
      totalCouponsAcceptedRef
      totalCouponsRedRef
      totalConversionRateRef
      smsCampaignOptOut
      totalRefClicks
      attachedTags: tags
    }
  }
`;

export const GET_SU_DASHBOARD_STAT_CONTACTS = gql`
  query getSuperAdminDashboardStatContacts($query: DashboardStatContactsQuery) {
    getSuperAdminDashboardStatContacts(query: $query) {
      _id
      phoneNumber
      organizationName
      organizationId
      createdAt
      lastImported
      attendedOrganization
      welcomed
      currentAvailableBalance
      originalSource
      optInMethod
      lastOptIn
      optOut
      totalCreditGranted
      totalCreditRedeemed
      totalCouponsGranted
      totalCouponsRedeemed
      totalCouponsAcceptedRef
      totalCouponsRedRef
      totalConversionRateRef
      smsCampaignOptOut
      totalRefClicks
    }
  }
`;

export const GET_CONTACT_TRANSACTIONS = gql`
  query getContactTransactions($phoneNumber: String!, $organizationId: String) {
    getContactTransactions(
      phoneNumber: $phoneNumber
      organizationId: $organizationId
    ) {
      time
      type
      amount
      campaignName
      refferrerPhoneNumber
    }
  }
`;

export const ADD_CONTACT_TAG = gql`
  mutation updateOrgTags($tags: [String]) {
    updateOrgTags(tags: $tags) {
      _id
      tags
    }
  }
`;
export const DELETE_CONTACT_TAGS = gql`
  mutation removeOrgTag($tag: String!) {
    removeOrgTag(tag: $tag) {
      _id
      tags
    }
  }
`;

export const UPDATE_ATTACHED_TAGS = gql`
  mutation updateContactTags($phoneNumber: String!, $tags: [String]!) {
    updateContactTags(phoneNumber: $phoneNumber, tags: $tags) {
      _id
      phoneNumber
      tags
    }
  }
`;

export const DETACH_CONTACT_TAG = gql`
  mutation removeContactTags($phoneNumber: String!, $tags: [String!]!) {
    removeContactTags(phoneNumber: $phoneNumber, tags: $tags) {
      _id
    }
  }
`;

/************************************************
  Message
 ************************************************/

export const SEND_CUSTOM_TEXT = gql`
  mutation sendCustomText(
    $phoneNumber: String!
    $message: String!
    $mediaUrl: String
    $organizationId: String
    $messageType: String
  ) {
    sendCustomText(
      phoneNumber: $phoneNumber
      message: $message
      mediaUrl: $mediaUrl
      organizationId: $organizationId
      messageType: $messageType
    )
  }
`;

export const SEND_WELCOME_TEXT = gql`
  mutation sendWelcomeText($phoneNumbers: [String]) {
    sendWelcomeText(phoneNumbers: $phoneNumbers)
  }
`;

/************************************************
  Coupon
 ************************************************/

export const GET_COUPON_BALANCE_TO_REDEEM = gql`
  query getCouponBalanceToRedeem($phoneNumber: String!) {
    getCouponBalanceToRedeem(phoneNumber: $phoneNumber)
  }
`;

export const GET_ACTIVE_COUPONS = gql`
  query getActiveCoupons($phoneNumber: String!) {
    getActiveCoupons(phoneNumber: $phoneNumber) {
      _id
      amount
      redemptionExpiration
    }
  }
`;

export const REDEEM_COUPON = gql`
  mutation redeemCoupon($phoneNumber: String!) {
    redeemCoupon(phoneNumber: $phoneNumber)
  }
`;

export const REDEEM_SELECTED_COUPONS = gql`
  mutation redeemCoupons($coupons: [String]!, $phoneNumber: String!) {
    redeemCoupons(coupons: $coupons, phoneNumber: $phoneNumber)
  }
`;

export const GET_REFFERED_CONTACTS = gql`
  query getReferedContacts(
    $phoneNumber: String!
    $couponType: String
    $organizationId: String
  ) {
    getReferedContacts(
      phoneNumber: $phoneNumber
      couponType: $couponType
      organizationId: $organizationId
    ) {
      _id
      phoneNumber
      organizationId
      createdAt
      lastImported
      attendedOrganization
      welcomed
      currentAvailableBalance
      originalSource
      optInMethod
      lastOptIn
      optOut
      totalCreditGranted
      totalCreditRedeemed
      totalCouponsGranted
      totalCouponsRedeemed
      totalCouponsAcceptedRef
      totalCouponsRedRef
      totalConversionRateRef
      smsCampaignOptOut
      organizationName
      totalRefClicks
      attachedTags: tags
    }
  }
`;

export const GET_ORG_TOP_REFERRERS = gql`
  query getOrgTopReferers {
    getOrgTopReferers {
      _id
      phoneNumber
      totalAccepted
      totalRedeemed
      conversionRate
      totalAmountAccepted
      totalAmountRedeemed
    }
  }
`;

/************************************************
  Metrics
 ************************************************/

export const GET_ORGANIZATION_METRICS = gql`
  query getOrganizationMetrics($start: Int!, $end: Int!) {
    getOrganizationMetrics(start: $start, end: $end) {
      couponsRedeemedTotal
      couponsRedeemedNew
      couponsRedeemedRepeat
      couponsRedeemedAffiliate
      couponsGrantedTotal
      couponsGrantedNew
      couponsGrantedRepeat
      couponsGrantedAffiliate
      creditRedeemedTotal
      creditRedeemedNew
      creditRedeemedRepeat
      creditRedeemedAffiliate
      creditGrantedTotal
      creditGrantedNew
      creditGrantedRepeat
      creditGrantedAffiliate
      contactsWelcomed
      couponsExpiredWithoutRedemption
      campaignMetrics {
        noOfCampaigns
        totalMessagesSent
        noOfConversions
      }
    }
  }
`;

export const GET_USER_METRICS = gql`
  query getUserMetrics($phoneNumber: String!) {
    getUserMetrics(phoneNumber: $phoneNumber) {
      # coupon stats
      currentAvailableBalance
      totalCreditGranted
      totalCreditRedeemed
      totalCouponsGranted
      totalCouponsRedeemed
      # Referral stats
      totalCouponsAcceptedRef
      totalCouponsRedRef
      totalConversionRateRef
    }
  }
`;

export const GET_SUPERADMIN_METRICS = gql`
  query getSuperAdminMetric($start: Int!, $end: Int!) {
    getSuperAdminMetrics(start: $start, end: $end) {
      upcomingRevenue
      lifeTimeRevenue
      totalClients
      totalContacts
      totalCouponsRedeemed
      totalCouponsRedeemedNew
      totalCouponsRedeemedRepeat
      totalCouponsRedeemedAffiliate
      totalCreditRedeemed
      totalCreditRedeemedNew
      totalCreditRedeemedRepeat
      totalCreditRedeemedAffiliate
      totalCreditActivated
      totalCreditActivatedNew
      totalCreditActivatedRepeat
      totalCreditActivatedAffiliate
      totalCouponsActivated
      totalCouponsActivatedNew
      totalCouponsActivatedRepeat
      totalCouponsActivatedAffiliate
      totalContactsWelcomed
      totalMinMonthlyCharges
      totalCreditUsed
      
    }
  }
`;

/************************************************
  File Upload
 ************************************************/

export const UPLOAD_FILES = gql`
  mutation uploadFiles($files: [Upload!]!) {
    uploadFiles(files: $files) {
      filename
      mimetype
      encoding
      url
    }
  }
`;

export const UPLOAD_ORG_FILES = gql`
  mutation uploadOrgFiles($files: [Upload!]!) {
    uploadOrgFiles(files: $files) {
      filename
      mimetype
      encoding
      url
    }
  }
`;

/************************************************
  Payment
 ************************************************/

export const CREATE_STRIPE_CUSTOMER = gql`
  mutation createStripeCustomer($cardToken: String!) {
    createStripeCustomer(cardToken: $cardToken)
  }
`;

export const LIST_INVOICES = gql`

  query listInvoices{
    listInvoices {
      _id
      subscriptionId
      organizationId
      subscriptionCycleStartDate
      subscriptionCycleEndDate
      paidAt
      totalAmountDue
      newCustomerCost
      repeatCustomerCost
      affiliateCustomerCost
      newCustomerAmount
      repeatCustomerAmount
      affiliateCustomerAmount
      stripeChargeId
      creditCardProcessingFee
      description
      campaignCharges
      totalCampaignCreditsUsed
      campaignStats {
        sms {
          numberSent
          charges
          creditUsed
        }
        mms {
          numberSent
          charges
          creditUsed
        }
      }
      type,
      additionalAmount,
      organizationMinMonthlyCharges,
    }
  }
`;

export const GET_CURRENT_PAYMENT_INFO = gql`
  query getCurrentPaymentInfo {
    getCurrentPaymentInfo {
      brand
      last4
      expMonth
      expYear
    }
  }
`;

export const CHANGE_PAYMENT_METHOD = gql`
  mutation changePaymentMethod($cardToken: String!) {
    changePaymentMethod(cardToken: $cardToken)
  }
`;

export const CANCEL_SUBSCRIPTION = gql`
  mutation cancelSubScription {
    cancelSubscription
  }
`;

export const GET_TIMEZONES = gql`
  query getTimezones {
    timezones: getTimezones {
      timezonesArray: timezones {
        value: _id
        label: zoneName
        name
        offset
        dstOffset
      }
      defaultTimezone {
        value: _id
        label: zoneName
        name
        offset
        dstOffset
      }
    }
  }
`;

/************************************************
  SMS Templates
 ************************************************/

export const GET_SMS_TEMPLATES = gql`
  query getCampaignTemplates {
    templates: getCampaignTemplates {
      _id
      text
    }
  }
`;

export const CREATE_SMS_TEMPLATE = gql`
  mutation createCampaignTemplate($text: String!) {
    createCampaignTemplate(text: $text) {
      _id
      text
    }
  }
`;

export const UPDATE_SMS_TEMPLATE = gql`
  mutation updateCampaignTemplate($campaignTemplateId: String, $text: String) {
    updateCampaignTemplate(
      campaignTemplateId: $campaignTemplateId
      text: $text
    ) {
      _id
      text
    }
  }
`;

export const DELETE_SMS_TEMPLATE = gql`
  mutation deleteCampaignTemplate($campaignTemplateId: String) {
    deleteCampaignTemplate(campaignTemplateId: $campaignTemplateId) {
      _id
      text
    }
  }
`;

/************************************************
  SMS Campaigns
 ************************************************/

export const ACTIVATE_SMS_CAMPAIGNS = gql`
  mutation {
    activateSmsCampaign {
      phoneNumber
      campaignPhoneNumber
    }
  }
`;

export const GET_CAMPAIGN_CONFIG = gql`
  query {
    getDataForCampaign {
      mmsEnabled
      shortUrlDomain
    }
  }
`;

export const GET_SMS_CAMPAIGNS = gql`
  query getCampaigns ($isTriggerCampaign: Boolean){
    getCampaigns (isTriggerCampaign: $isTriggerCampaign){
      _id
      name
      type
      text
      tags
      numberSent
      creditsUsed
      unsubscribeMessage
      status
      dateTime
      executionStatus
      optOuts
      sendMode
      totalUrlClicks
      isTriggerCampaign
      events
    }
  }
`;

export const GET_SUPERADMIN_CAMPAIGNS = gql`
  query getSuperAdminCampaigns($query: SuperAdminCampaignsInput) {
    getSuperAdminCampaigns(query: $query) {
      _id
      organizationName
      name
      type
      text
      tags
      numberSent
      creditsUsed
      status
      dateTime
      executionStatus
      optOuts
      sendMode
      totalUrlClicks
      isTriggerCampaign
    }
  }
`;

export const CREATE_CAMPAIGN = gql`
  mutation createCampaign(
    $name: String!
    $text: String!
    $unsubscribeMessage: String!
    $status: String!
    $imageUrl: String
    $type: String!
    $dateTime: String
    $referralOptInText: String!
    $referralOptIn: Boolean!
    $isUrlShortningEnabled: Boolean
    $tags:[String]
    $isTriggerCampaign:Boolean
    $events:[String]
  ) {
    campaign: createCampaign(
      name: $name
      text: $text
      unsubscribeMessage: $unsubscribeMessage
      status: $status
      imageUrl: $imageUrl
      type: $type
      tags: $tags
      dateTime: $dateTime
      referralOptInText: $referralOptInText
      referralOptIn: $referralOptIn
      isUrlShortningEnabled: $isUrlShortningEnabled
      isTriggerCampaign:$isTriggerCampaign
      events:$events
    ) {
      _id
      name
      unsubscribeMessage
      text
      status
      creditsUsed
      imageUrl
      numberSent
      dateTime
      sendMode
      executionStatus
      tags
    }
  }
`;

export const GET_CAMPAIGN = gql`
  query getCampaignById($campaignId: String!) {
    campaign: getCampaignById(campaignId: $campaignId) {
      _id
      name
      unsubscribeMessage
      text
      type
      status
      creditsUsed
      imageUrl
      numberSent
      dateTime
      executionStatus
      optOuts
      tags
      sendMode
      referralOptInText
      referralOptIn
      isUrlShortningEnabled
      totalUrlClicks
      isTriggerCampaign
      events
      shortUrls {
        shortUrl
        clicks
        originalUrl
      }
    }
  }
`;

export const UPDATE_CAMPAIGN = gql`
  mutation updateCampaign(
    $campaignId: String!
    $name: String!
    $text: String!
    $unsubscribeMessage: String!
    $status: String!
    $imageUrl: String
    $type: String!
    $dateTime: String
    $referralOptInText: String!
    $referralOptIn: Boolean!
    $isUrlShortningEnabled: Boolean
    $tags:[String]
   $isTriggerCampaign:Boolean
    $events:[String]
  ) {
    campaign: updateCampaign(
      campaignId: $campaignId
      name: $name
      text: $text
      unsubscribeMessage: $unsubscribeMessage
      status: $status
      imageUrl: $imageUrl
      type: $type
      dateTime: $dateTime
      tags:$tags
      referralOptInText: $referralOptInText
      referralOptIn: $referralOptIn
      isUrlShortningEnabled: $isUrlShortningEnabled
      isTriggerCampaign:$isTriggerCampaign
      events:$events
    ) {
      _id
      name
      unsubscribeMessage
      text
      tags
      status
      creditsUsed
      imageUrl
      numberSent
      dateTime
      sendMode
      executionStatus
    }
  }
`;

export const DELETE_CAMPAIGN = gql`
  mutation deleteCampign($campaignId: String!) {
    deleteCampaign(campaignId: $campaignId) {
      _id
    }
  }
`;

export const TEST_CAMPAIGN = gql`
  mutation testCampaign(
    $name: String!
    $text: String!
    $unsubscribeMessage: String!
    $status: String!
    $imageUrl: String
    $type: String!
    $dateTime: String
    $referralOptInText: String!
    $referralOptIn: Boolean!
    $customNumbers: [String]
  ) {
    campaign: testCampaign(
      name: $name
      text: $text
      unsubscribeMessage: $unsubscribeMessage
      status: $status
      imageUrl: $imageUrl
      type: $type
      dateTime: $dateTime
      referralOptInText: $referralOptInText
      referralOptIn: $referralOptIn
      customNumbers: $customNumbers
    ) {
      message
      success
    }
  }
`;
export const MOST_RECENT_CAMPAIGN = gql`
  query getMostRecentCampaign($dateTime: String!, $campaignId: String){
    campaign: getMostRecentCampaign(dateTime: $dateTime, campaignId: $campaignId) {
      dateTime
      status
      executionStatus
    }
  }
`;
export const GET_CONTACT_BY_TAGS = gql`
  query getContactByTags($tags: [String]!, $isTriggerCampaign: Boolean) {
    getContactByTags(tags: $tags, isTriggerCampaign: $isTriggerCampaign)
  }
`;

export const SET_MMS_ENABLED = gql`
  mutation updateMMSActivation($organizationId: String!, $mmsEnabled: String!) {
    updateMMSActivation(
      organizationId: $organizationId
      mmsEnabled: $mmsEnabled
    ) {
      _id
    }
  }
`;

/************************************************
  SMS Campaigns
 ************************************************/

export const MUTATE_ANALYTICS = gql`
  mutation createUsageStat($link: String!) {
    createUsageStat(link: $link) {
      _id
    }
  }
`;

export const RESET_ORG = gql`
  mutation resetOrganization($organizationId: String!) {
    resetOrganization(organizationId: $organizationId) {
      _id
      name
      createdAt
      ltv
      upcomingRevenue
      cycleStartAt
      cycleEndAt
      campaignPhoneNumber
      phoneNumber
      mmsEnabled
      totalContacts
      totalCampaigns
      campaignCreditsUsed
    }
  }
`;

export const GET_ENV_DATA = gql`
  query getEnvData {
    getEnvData {
      nodeEnv
      embedScriptUrl
    }
  }
`;
